var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFeature3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_042-cube",
    "data-name": "042-cube",
    transform: "translate(-30 -30)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_237",
    "data-name": "Path 237",
    d: "M78,54a4.808,4.808,0,0,0-3.2-4.525V39.437a1.6,1.6,0,0,0-3.2,0V49.475a4.829,4.829,0,0,0-.468.194L65.863,44.4l5.859-5.859a1.6,1.6,0,0,0-.76-2.686,1.6,1.6,0,0,0-1.2-2.655H58.525a4.8,4.8,0,0,0-9.05,0H39.3a1.6,1.6,0,0,0-1.2,2.657,1.6,1.6,0,0,0-2.191,1.276A1.6,1.6,0,0,0,33.2,38.286V49.475a4.8,4.8,0,0,0,0,9.05V69.9a1.6,1.6,0,0,0,2.376,1.4,1.6,1.6,0,0,0,2.329.974,1.6,1.6,0,0,0,1.3,2.527H49.475a4.8,4.8,0,0,0,9.051,0c.027,0,.054,0,.081,0H69.4a1.6,1.6,0,0,0,1.238-2.613c.036,0,.071.005.107.005a1.6,1.6,0,0,0,1.538-1.16A1.6,1.6,0,0,0,74.8,69.721v-11.2A4.808,4.808,0,0,0,78,54Zm-9.131-2.068a4.795,4.795,0,0,0,0,4.136L63.677,61.26,56.34,53.923l7.26-7.26Zm-12.8,16.937a4.795,4.795,0,0,0-4.136,0L46.663,63.6l7.414-7.414,7.337,7.337ZM39.131,51.932l5.346-5.346,7.337,7.337L44.4,61.337l-5.269-5.269a4.8,4.8,0,0,0,0-4.137Zm12.8-12.8a4.795,4.795,0,0,0,4.136,0L61.337,44.4l-7.26,7.26L46.74,44.323Zm6.4-2.263a4.732,4.732,0,0,0,.194-.468H69.337L63.6,42.137ZM54,33.2a1.6,1.6,0,0,1,1.593,1.468c0,.044-.007.088-.007.132s0,.089.007.132A1.6,1.6,0,1,1,54,33.2Zm-4.525,3.2a4.829,4.829,0,0,0,.194.468L44.477,42.06,38.7,36.284a1.593,1.593,0,0,0,.6.116Zm-7.261,7.923-5.346,5.346a4.731,4.731,0,0,0-.468-.194V38.508ZM34.8,52.4A1.6,1.6,0,1,1,33.2,54,1.6,1.6,0,0,1,34.8,52.4Zm1.6,16.937V58.525a4.83,4.83,0,0,0,.468-.194L42.137,63.6Zm2.093,2.433L44.4,65.863l5.269,5.269a4.732,4.732,0,0,0-.194.468H39.207A1.593,1.593,0,0,0,38.493,71.77ZM54,74.8a1.6,1.6,0,1,1,1.6-1.6A1.6,1.6,0,0,1,54,74.8Zm4.607-3.2c-.027,0-.054,0-.081,0a4.766,4.766,0,0,0-.2-.472l5.346-5.346L69.5,71.6c-.032,0-.063,0-.1,0H58.607Zm7.333-8.077,5.192-5.192a4.731,4.731,0,0,0,.468.194V69.183ZM73.2,55.6A1.6,1.6,0,1,1,74.8,54,1.6,1.6,0,0,1,73.2,55.6Z",
    fill: "#727272"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_33",
    "data-name": "Group 33",
    transform: "translate(30 30)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_238",
    "data-name": "Path 238",
    d: "M226.8,39.6a4.8,4.8,0,1,1,4.8-4.8A4.805,4.805,0,0,1,226.8,39.6Zm0-6.4a1.6,1.6,0,1,0,1.6,1.6A1.6,1.6,0,0,0,226.8,33.2Z",
    transform: "translate(-183.6 -30)",
    fill: "#051ee1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_239",
    "data-name": "Path 239",
    d: "M34.8,39.6a4.8,4.8,0,1,1,4.8-4.8A4.805,4.805,0,0,1,34.8,39.6Zm0-6.4a1.6,1.6,0,1,0,1.6,1.6A1.6,1.6,0,0,0,34.8,33.2Z",
    transform: "translate(-30 -30)",
    fill: "#051ee1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_240",
    "data-name": "Path 240",
    d: "M226.8,231.6a4.8,4.8,0,1,1,4.8-4.8A4.805,4.805,0,0,1,226.8,231.6Zm0-6.4a1.6,1.6,0,1,0,1.6,1.6A1.6,1.6,0,0,0,226.8,225.2Z",
    transform: "translate(-183.6 -183.6)",
    fill: "#051ee1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_241",
    "data-name": "Path 241",
    d: "M34.8,231.6a4.8,4.8,0,1,1,4.8-4.8A4.805,4.805,0,0,1,34.8,231.6Zm0-6.4a1.6,1.6,0,1,0,1.6,1.6A1.6,1.6,0,0,0,34.8,225.2Z",
    transform: "translate(-30 -183.6)",
    fill: "#051ee1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeature3);
export default __webpack_public_path__ + "static/media/feature_3.77ba35a201b5b6a8872d65f50a72d3e7.svg";
export { ForwardRef as ReactComponent };